import { differenceInCalendarDays, addDays, subDays } from 'date-fns'

const fechas = {
    getHoy() {
        const hoy=new Date()
        const fecha=String(hoy.getFullYear())+"-"+String(hoy.getMonth()+1).padStart(2, "0")+"-"+String(hoy.getDate()).padStart(2, "0")
        return fecha
    },

    getDistanciaEntreFechas(fecha1, fecha2) {
        const fechaDiferencia1=new Date(fecha1.substr(0, 4), parseInt(fecha1.substr(5, 2))-1, fecha1.substr(8, 2))
        const fechaDiferencia2=new Date(fecha2.substr(0, 4), parseInt(fecha2.substr(5, 2))-1, fecha2.substr(8, 2))
        return differenceInCalendarDays(fechaDiferencia1, fechaDiferencia2)                    
    },

    isValidDate (dateString) {
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        if(!dateString.match(regEx)) return false;  // Invalid format
        var d = new Date(dateString);
        var dNum = d.getTime();
        if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
        return d.toISOString().slice(0,10) === dateString;
    },    

    // getSumarDiasFecha (diasASumar, fechaBase)  {
    //     if (fechaBase==null) {
    //         fechaBase=new Date()
    //     }
    //     let operadorDias
    //     if (diasASumar>=0) {
    //         // operadorDias=require("date-fns/addDays")
    //         operadorDias=addDays
    //     } else {
    //         // operadorDias=require("date-fns/subDays")
    //         operadorDias=subDays
    //     }
    //     const result=operadorDias(fechaBase, Math.abs(diasASumar))
    //     return result
    // }, 

    getSumarDiasFecha (diasASumar, fechaBase)  {
        if (fechaBase==null) {
            fechaBase=new Date()
        }
        fechaBase.setDate(fechaBase.getDate() + diasASumar)
        return fechaBase
    }, 



    dateToString (fecha)  {
        const result=String(fecha.getFullYear())+"-"+String(fecha.getMonth()+1).padStart(2, "0")+"-"+String(fecha.getDate()).padStart(2, "0")
        return result
    }
    
    
}

export default fechas